export type WhatsappCompletionMessages = {
  whatsappCompletionMessagesText1Part1: string;
  whatsappCompletionMessagesText1Part2: string;
};

export const whatsappCompletionMessages: WhatsappCompletionMessages = {
  whatsappCompletionMessagesText1Part1:
    "Seu número foi ativado com sucesso, agora seu WhatsApp está conectado a Talk2Buy.",
  whatsappCompletionMessagesText1Part2:
    "Clique em concluir e ative seu agente de vendas agora mesmo!",
};
